// Russian translations (Русский)
export const ru = {
  // Navigation
  nav: {
    home: "Главная",
    rooms: "Номера",
    amenities: "Удобства",
    gallery: "Галерея",
    virtualTour: "Виртуальный Тур",
    location: "Расположение",
    contact: "Контакты",
    bookNow: "Забронировать"
  },
  
  // Hero
  hero: {
    tagline: "Семейный отель 3*, 2 минуты от пляжа Велика Плажа, Улцинь",
    description: "Простой семейный отель 3* на мысе Кепи-и-Джеранаве, примерно в 2 минутах ходьбы от песка в начале Велика Плажа — 12-километрового пляжа Улциня. Завтрак, ужин, бассейн, Wi-Fi и гараж включены. Номера чистые и функциональные, без роскоши — в большинстве есть балкон, многие выходят на море.",
    exploreRooms: "Смотреть Номера",
    viewGallery: "Смотреть Галерею",
    veryGood: "Очень Хорошо",
    reviews: "отзывов",
    starHotel: "Отель 3 звезды",
    bookDirect: "Бронируйте напрямую и экономьте",
    bestPrice: "Дешевле, чем на Booking.com, за тот же номер",
    freeCancellation: "Бесплатная отмена для гибких тарифов",
    noBookingFees: "Без сборов за бронирование",
    checkAvailability: "Проверить наличие →"
  },
  
  // Booking
  booking: {
    checkAvailability: "Проверить Наличие и Забронировать",
    checkIn: "Заезд",
    checkOut: "Выезд",
    adults: "Взрослые",
    children: "Дети",
    adult: "Взрослый",
    child: "Ребёнок",
    searchAvailability: "Поиск Наличия",
    secureBooking: "Безопасное бронирование • Гарантия лучшей цены • Бесплатная отмена для большинства номеров",
    freeCancellation: "Бесплатная отмена для большинства бронирований"
  },
  
  // Rooms
  rooms: {
    title: "Простые чистые номера у пляжа",
    subtitle: "Размещение",
    description: "13 типов номеров — от компактного одноместного до апартаментов с двумя спальнями. В каждом кондиционер, своя ванная и бесплатный Wi-Fi; в большинстве балкон. Мебель функциональная, не дизайнерская.",
    viewDetails: "Подробнее",
    bookNow: "Забронировать",
    perNight: "/ночь",
    guests: "Гостей",
    backToRooms: "Вернуться к Номерам",
    roomAmenities: "Удобства Номера",
    standardFeatures: "Стандартное Оснащение"
  },
  
  // Room Names (Russian)
  roomNames: {
    room1: "Двухместный номер с видом на море и балконом",
    room2: "Двухместный номер у бассейна",
    room3: "Экономичный двухместный номер с балконом (без вида)",
    room4: "Двухместный номер с двумя кроватями, видом на море и общей террасой",
    room5: "Представительский трёхместный номер с видом на море и балконом",
    room6: "Двухместный номер с дополнительной кроватью - вид на море и балкон",
    room7: "Двухкомнатные семейные апартаменты",
    room8: "Семейный номер с общей террасой",
    room9: "Семейный номер с террасой",
    room10: "Маленький одноместный номер",
    room11: "Трёхместный номер с балконом",
    room12: "Семейный номер с видом на горы",
    room13: "Однокомнатные апартаменты"
  },
  
  // Amenities
  amenities: {
    title: "Удобства Отеля",
    subtitle: "Что Мы Предлагаем",
    beachfront: "Расположение на Пляже",
    beachfrontDesc: "Прямой выход на Длинный пляж",
    childrenPool: "Детский Бассейн",
    childrenPoolDesc: "Безопасный бассейн для семей",
    restaurant: "Ресторан и Кафе",
    restaurantDesc: "Балканская кухня · без алкоголя",
    wifi: "Бесплатный WiFi",
    wifiDesc: "Высокоскоростной интернет",
    parking: "Бесплатная Парковка",
    parkingDesc: "Охраняемая парковка",
    shuttle: "Трансфер из Аэропорта",
    shuttleDesc: "€80 из аэропортов Подгорица и Тиват (по запросу)",
    frontDesk: "Круглосуточная Стойка Регистрации",
    frontDeskDesc: "Сервис 24/7",
    elevator: "Лифт",
    elevatorDesc: "Все этажи"
  },
  
  // Gallery
  gallery: {
    intro: "Откройте для себя красоту отеля La Rosa Negra и очарование Улциня.",
    title: "Фотогалерея",
    subtitle: "Исследуйте Наш Отель",
    all: "Все",
    rooms: "Номера",
    pool: "Бассейн",
    beach: "Пляж",
    restaurant: "Ресторан",
    exterior: "Экстерьер"
  },
  
  // Virtual Tour
  virtualTour: {
    title: "Виртуальный Тур 360°",
    subtitle: "Познакомьтесь с Отелем",
    description: "Совершите виртуальную прогулку по нашему прекрасному отелю"
  },
  
  // Location
  location: {
    title: "Наше Расположение",
    subtitle: "Как Нас Найти",
    address: "Адрес",
    nearbyAttractions: "Достопримечательности Поблизости"
  },
  
  // Contact
  contact: {
    title: "Свяжитесь с Нами",
    subtitle: "Напишите Нам",
    name: "Имя",
    email: "Email",
    message: "Сообщение",
    send: "Отправить Сообщение",
    phone: "Телефон",
    whatsapp: "WhatsApp"
  },
  
  // FAQ
  faq: {
    intro: "Ответы на частые вопросы об отеле La Rosa Negra.",
    title: "Часто Задаваемые Вопросы",
    subtitle: "FAQ"
  },
  
  // Footer
  footer: {
    quickLinks: "Быстрые Ссылки",
    contactInfo: "Контактная Информация",
    followUs: "Подписывайтесь",
    rights: "Все права защищены",
    starHotel: "звёздочный отель",
    description: "Откройте для себя идеальное сочетание средиземноморского очарования и современного комфорта прямо на Великой пляже в Улцине, Черногория.",
    rooms: "Номера и Сьюты",
    amenities: "Удобства",
    gallery: "Галерея",
    location: "Расположение",
    reviews: "Отзывы",
    legal: "Юридическое",
    privacy: "Политика конфиденциальности",
    terms: "Условия использования",
    cookies: "Политика cookies",
    cancellation: "Политика отмены"
  },

  // Smart language-hint toast
  langHint: {
    message: "Эта страница также доступна на русском языке",
    switch: "Переключить",
    dismiss: "Закрыть"
  },
  
  // Why Book Direct
  whyBookDirect: {
    eyebrow: "Прямое бронирование",
    heading: "Почему бронировать напрямую?",
    lead: "Здесь дешевле, чем на Booking.com, и вы общаетесь напрямую с нами — вот что именно вы получаете",
    b1t: "Дешевле, чем на Booking.com",
    b1d: "Наша прямая цена на 10% ниже нашей цены на Booking.com за тот же номер и даты. Нашли дешевле там? Пришлите ссылку — уравняем.",
    b2t: "Скидка 10%",
    b2d: "Эти 10% уже учтены в цене, которую вы видите — без кода и дополнительных сборов.",
    b3t: "Понятные условия отмены",
    b3d: "Гибкие тарифы отменяются бесплатно до даты, указанной при бронировании; невозвратные тарифы помечены до оплаты.",
    b4t: "Отвечает человек",
    b4d: "WhatsApp, телефон или e-mail — ресепшен обычно отвечает в течение нескольких часов, 08:00–23:00.",
    cta: "Бронируйте напрямую и экономьте"
  },

  // Amenities section headings/CTA
  amenitiesSection: {
    eyebrow: "Удобства",
    heading: "Что есть в отеле",
    lead: "Только то, что действительно есть — ни больше, ни меньше.",
    ctaTitle: "Вопросы перед бронированием?",
    ctaLead: "Спрашивайте о номерах, пляже или дороге — отвечаем честно.",
    ctaButton: "Связаться с консьержем"
  },

  // Contact section
  contactForm: {
    title: "Напишите нужному отделу",
    subtitle: "Выберите отдел — мы ответим в течение одного рабочего дня.",
    dep_sales: "Отдел продаж", hint_sales: "Групповые брони, мероприятия, корпоративные тарифы, агентства",
    dep_jobs: "Вакансии", hint_jobs: "Отправьте резюме — ресепшн, хаускипинг, F&B, техслужба",
    dep_pr: "Связи с общественностью", hint_pr: "Пресса, медиа, партнёрства и сотрудничество",
    name: "Ваше имя", email: "Электронная почта", phone: "Телефон (необязательно)", subject: "Тема", position: "Желаемая должность",
    message: "Ваше сообщение", messageJobs: "Расскажите о себе, опыте и доступности",
    attachCv: "Прикрепить резюме (PDF или Word, до 5 МБ)", send: "Отправить",
    successTitle: "Сообщение отправлено!", successBody: "Спасибо — ваше сообщение получил отдел:", sendAnother: "Отправить ещё",
    error: "Не удалось отправить. Попробуйте ещё раз.", privacy: "Мы используем ваши данные только для ответа на запрос."
  },
  contactSection: {
    eyebrow: "Свяжитесь с нами",
    heading: "Напишите нам",
    lead: "Есть вопросы? Мы здесь, чтобы помочь. Свяжитесь с нами в любое время.",
    addressLabel: "Адрес",
    phoneLabel: "Телефон",
    emailLabel: "Email",
    receptionLabel: "Часы работы стойки регистрации",
    reception247: "24/7 - Мы всегда здесь для вас",
    whatsappBtn: "Написать в WhatsApp",
    emailBtn: "Отправить email",
    bookDirectTitle: "Бронируйте напрямую и экономьте",
    bookDirectDesc: "Получите 10% скидку при бронировании на нашем сайте",
    checkAvailability: "Проверить наличие",
    whatsappPrefill: "Здравствуйте, хочу узнать об отеле La Rosa Negra"
  },

  // Reviews section
  reviews: {
    eyebrow: "Отзывы гостей",
    heading: "Что говорят гости — без правок",
    lead: "Отзывы скопированы с Booking.com как есть, включая критику. Судите сами.",
    veryGood: "Очень хорошо",
    reviewsCount: "отзывов",
    starHotel: "Отель 3 звезды",
    readMoreOn: "Читайте больше отзывов на",
    translatedFrom: "Переведено с: {lang}",
    showOriginal: "Показать оригинал",
    showTranslation: "Показать перевод"
  },

  // Handoff
  handoff: {
    prompt: "Хотите поговорить с нашей командой?",
    button: "Продолжить в WhatsApp",
    prefix: "Здравствуйте, Hotel La Rosa Negra! Я общался(лась) с вашим виртуальным ассистентом и хотел(а) бы продолжить с сотрудником."
  },

  // Common
  common: {
    learnMore: "Узнать Больше",
    seeAll: "Смотреть Все",
    close: "Закрыть",
    loading: "Загрузка..."
  }
};
